import { message } from "antd";
import apiClient from "../Network";

export const statusMenuCash = [
  {
    title: "Approve",
    action: (id: string | number) => handleAction(`/${id}/approve`),
  },
  {
    title: "Reject",
    action: (id: string | number) => handleAction(`/${id}/reject`),
  },
  {
    title: "Complete",
    action: (id: string | number) => handleAction(`/${id}/complete`),
  },
  {
    title: "Cancel",
    action: (id: string | number) => handleAction(`/${id}/cancel`),
  },
];

export const statusMenuNotCash = [
  {
    title: "Reject",
    action: (id: string | number) => handleAction(`/${id}/reject`),
  },
  {
    title: "Cancel",
    action: (id: string | number) => handleAction(`/${id}/cancel`),
  },
  {
    title: "Change Payment To Cash",
    action: (id: string | number) =>
      handleAction(`/change-payment-method`, {
        serviceRequestId: id,
        paymentMethod: "cash",
      }),
  },
  {
    title: "Complete",
    action: (id: string | number) => handleAction(`/${id}/complete`),
  },
];

export const handleAction = async (
  url: string,
  body?: any,
  refetch?: any,
  hideMessage?: boolean
) => {
  try {
    await apiClient.post(`service-request${url}`, body);
    !hideMessage && message.success(`Status Change successfully`);
    refetch();
  } catch (error) {
    if (error?.response?.data?.message)
      message.error(
        error?.response?.data?.message || "Can't Change Request Status"
      );
  }
};

export const statusMap = (status: string, isPaid?: boolean) => {
  if (status === "pending") return "Pending";
  if (status === "completed") return "Completed";
  if (status === "cancelled") return "Cancelled";
  if (status === "rejected") return "Rejected";
  if (status === "waitingAdminApproval") return "Waiting Admin Approval";
  if (status === "waitingPayment")
    return isPaid ? "In progress" : "Waiting Payment";
  if (status === "waitingCustomerApproval") return "Waiting Customer Approval";
  if (status === "inProgress") return "In Progress";
  return status;
};
